@if (form) {
  <div class="bg-white m-2">
    <div class="border-bottom border-gray">
      <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h3 class="text-secondary pb-2">Recherche de doublon</h3>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <strong class="text-danger">Seuls les nouveaux dossiers rentrant dans le cadre du suivi hors RSA doivent être créés manuellement</strong>
          </div>
          <div class="col-12 mt-2">
            <div class="form-check">
              <input
                id="approval"
                type="checkbox"
                class="form-check-input"
                formControlName="approval"
                name="approval"
                [class.is-invalid]="submitted && form.controls.approval.invalid"
                />
              <label for="approval" class="form-check-label mb-0 required"
                ><strong>J'atteste avoir l'autorisation de l'usager pour accéder à ses informations personnelles</strong></label
                >
              </div>
              @if (submitted && form.controls.approval.errors?.required) {
                <small class="form-text text-danger mt-0"
                  >L'autorisation est obligatoire</small
                  >
                }
              </div>
              <div class="col-12 mt-2">
                <label for="firstName" class="required">Prénom</label>
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  formControlName="firstName"
                  [class.is-invalid]="submitted && form.controls.firstName.invalid"
                  />
                @if (submitted && form.controls.firstName.errors?.required) {
                  <small class="form-text text-danger mt-0">Le prénom est obligatoire</small>
                }
                @if (submitted && form.controls.firstName.errors?.maxlength) {
                  <small class="form-text text-danger"
                    >La taille maximale du prénom est de 32 caractères.</small
                    >
                  }
                  @if (submitted && form.controls.firstName.errors?.pattern) {
                    <small class="form-text text-danger"
                      >Les caractères spéciaux et les numéros ne sont pas autorisés.</small
                      >
                    }
                  </div>
                  <div class="col-12 mt-2">
                    <label for="usualName" class="required">Nom d'usage (recherche également sur le nom de famille)</label>
                    <input
                      type="text"
                      class="form-control"
                      id="usualName"
                      formControlName="usualName"
                      [class.is-invalid]="submitted && form.controls.usualName.invalid"
                      />
                    @if (submitted && form.controls.usualName.errors?.required) {
                      <small class="form-text text-danger mt-0">Le nom est obligatoire</small>
                    }
                    @if (submitted && form.controls.usualName.errors?.maxlength) {
                      <small class="form-text text-danger"
                        >La taille maximale du nom est de 32 caractères.</small
                        >
                      }
                      @if (submitted && form.controls.usualName.errors?.pattern) {
                        <small class="form-text text-danger"
                          >Les caractères spéciaux et les numéros ne sont pas autorisés.</small
                          >
                        }
                      </div>
                      <div class="col-12 mt-2">
                        <label for="birthDate" class="required">Date de naissance</label>
                        <app-datepicker formControlName="birthDate" id="birthDate" [invalid]="submitted && form.controls?.birthDate?.invalid"></app-datepicker>
                        @if (submitted && form.controls.birthDate.errors?.required) {
                          <small class="form-text text-danger mt-0"
                            >La date de naissance est obligatoire</small
                            >
                          }
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <div class="row w-100">
                      <div class="col-6 p-0 pe-1">
                        <button class="btn btn-secondary d-flex justify-content-center w-100" type="button" (click)="cancel()">Annuler</button>
                      </div>
                      <div class="col-6 p-0 ps-1">
                        <button class="btn btn-primary d-flex justify-content-center w-100" type="button" (click)="accept()">Valider</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
